import * as React from 'react';
import { TextField, FormControl} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { ITouch4WashConfig } from '../../_types/location';

interface Props {
    classes: any;
    /** the item to display */
    item: ITouch4WashConfig;
    onChange: (config: any) => void;
};

// LEARN
const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        }
//     home: { color: "primary" },
//     away: { color: theme.palette.grey[900] }
}));

const Touch4WashConfig: React.FC<Props> = (prop: Props) => {

    const classes = useStyles();

    return (
    <Grid container direction="row" alignItems="center">
  
        <Grid item>
            <FormControl className={classes.formControl}>
                <TextField label="Location Id" value={prop.item.LocationId} onChange={(e) => {let i = prop.item; i.LocationId = e.target.value; prop.onChange(i)}}></TextField>
            </FormControl>
        </Grid>
        <Grid item>
        <FormControl className={classes.formControl}>
                <TextField label="Account Number" value={prop.item.AccountNumber} onChange={(e) => {let i = prop.item; i.AccountNumber = e.target.value; prop.onChange(i)}}></TextField>
            </FormControl>
        </Grid>
    </Grid>
    );
}

export default Touch4WashConfig;